export function computeEstimatedTime(predictedHours, timeCommitment) {
  if (!predictedHours || !timeCommitment) return null;

  // Normalize commitment → weekly hours midpoint
  let weeklyHours = 5;
  if (/2–4/.test(timeCommitment)) weeklyHours = 3;
  else if (/5–10/.test(timeCommitment)) weeklyHours = 8;
  else if (/10–20/.test(timeCommitment)) weeklyHours = 15;
  else if (/15\+/.test(timeCommitment) || /Full/.test(timeCommitment)) weeklyHours = 25;

  // Estimated weeks = ceil(total hours / weekly capacity)
  const weeks = Math.ceil(predictedHours / weeklyHours);

  return { weeks, weeklyHours };
}
